<template>
  <span class="edit-role-button">
    <el-form
            ref="editRoleForm"
            :inline="true"
            :model="formData"
            :rules="rules"
            label-position="right"
    >
      <span v-if="formVisible">
        <el-form-item label="" prop="role_id">
          <el-select v-model.lazy.trim="formData.role_id" placeholder="Select role">
            <el-option
                    v-for="(role, index) in roles"
                    :key="index"
                    :label="role.name"
                    :value="role.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="submitForm()">Save</el-button>
          <el-button type="danger" size="mini" @click="cancel()">Cancel</el-button>
        </el-form-item>
      </span>
      <span v-else>
          <span>{{ currentRoleName }}</span> 
          <el-button @click="showForm()" size="mini"><i class="fas fa-pen"></i></el-button>
      </span>
    </el-form>
  </span>
</template>

<script>
  import { find } from 'lodash';
  import validations from '@/utils/validations';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'EditRoleButton',
    props: {
      userMembership: {
        required: true,
        default: () => [],
      },
      roles: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        formVisible: false,
        formData: {
          role_id: this.userMembership.role_id,
        },
        rules: {
          role_id: [
            { ...validations.required },
          ],
        },
      };
    },
    computed: {
      currentRoleName() {
        const currentRole = find(this.roles, ['id', this.formData.role_id]);
        return currentRole ? currentRole.name : 'No role yet!';
      },
    },
    methods: {
      showForm() {
        this.formVisible = true;
      },

      hideForm() {
        this.formVisible = false;
      },

      cancel() {
        this.hideForm();
        this.$refs.editRoleForm.resetFields();
      },

      submitForm() {
        this.$refs.editRoleForm.validate((valid) => {
          if (valid) {
            const currentRole = find(this.roles, ['id', this.formData.role_id]);
            if (currentRole) {
              this.$store.dispatch('entities/userMemberships/updateRole', { id: this.userMembership.id, data: this.formData })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Role has been updated successfully.');
                    this.hideForm();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            } else {
              // this.$store.dispatch('entities/userMemberships/inviteUser', { appId: this.app.id, data: this.formData })
              //   .then((response) => {
              //     if (response.status) {
              //       showSuccessMessage('Invitation email has been sent to the user.');
              //       this.$refs[formName].resetFields();
              //     } else {
              //       showErrorMessage(response.error);
              //     }
              //   });
            }
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },
    },
  };
</script>

<style lang="scss">
  .edit-role-button {
    .el-form {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/role/EditRoleButton.vue